var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 3.22133e-08 18.2091 0 16V7H5.33301C5.7012 7 6 6.77614 6 6.5C6 6.22386 5.7012 6 5.33301 6H0V5H3.5C3.77614 5 4 4.77614 4 4.5C4 4.22386 3.77614 4 3.5 4H0C0 1.79086 1.79086 3.22128e-08 4 0H16Z",
    fill: "url(#paint0_linear_2106_304)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03516 15.6973V14.4902C7.55078 14.4824 7.10352 14.4395 6.69336 14.3613C6.28711 14.2793 5.93555 14.1738 5.63867 14.0449V12.7969C5.93945 12.9375 6.31055 13.0645 6.75195 13.1777C7.19336 13.291 7.62109 13.3555 8.03516 13.3711V11.1738C7.46875 10.9824 7.00781 10.7832 6.65234 10.5762C6.30078 10.3691 6.04297 10.1289 5.87891 9.85547C5.71484 9.57812 5.63281 9.24609 5.63281 8.85938C5.63281 8.46094 5.73242 8.11914 5.93164 7.83398C6.13477 7.54492 6.41602 7.31641 6.77539 7.14844C7.13867 6.98047 7.55859 6.88086 8.03516 6.84961V5.89453H8.79688V6.83203C9.23047 6.84375 9.63086 6.89258 9.99805 6.97852C10.3691 7.06055 10.7227 7.17578 11.0586 7.32422L10.6309 8.41406C10.3379 8.29688 10.0332 8.20117 9.7168 8.12695C9.40039 8.05273 9.09375 8.00195 8.79688 7.97461V10.1191C9.27344 10.2754 9.69727 10.4434 10.0684 10.623C10.4434 10.8027 10.7363 11.0293 10.9473 11.3027C11.1621 11.5723 11.2695 11.9258 11.2695 12.3633C11.2695 12.9375 11.0586 13.4121 10.6367 13.7871C10.2148 14.1582 9.60156 14.3809 8.79688 14.4551V15.6973H8.03516ZM8.79688 13.3242C9.17188 13.2773 9.45117 13.1797 9.63477 13.0312C9.81836 12.8789 9.91016 12.6816 9.91016 12.4395C9.91016 12.2754 9.87109 12.1367 9.79297 12.0234C9.71875 11.9102 9.59961 11.8086 9.43555 11.7188C9.27539 11.6289 9.0625 11.541 8.79688 11.4551V13.3242ZM8.03516 9.83203V7.99805C7.80859 8.02148 7.61719 8.06836 7.46094 8.13867C7.30469 8.20898 7.1875 8.30078 7.10938 8.41406C7.03125 8.52734 6.99219 8.66211 6.99219 8.81836C6.99219 8.99023 7.02734 9.13672 7.09766 9.25781C7.16797 9.37891 7.2793 9.48438 7.43164 9.57422C7.58789 9.66406 7.78906 9.75 8.03516 9.83203Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 15.375C20.75 16.5353 20.2891 17.6481 19.4686 18.4686C18.6481 19.2891 17.5353 19.75 16.375 19.75C15.2147 19.75 14.1019 19.2891 13.2814 18.4686C12.4609 17.6481 12 16.5353 12 15.375C12 14.2147 12.4609 13.1019 13.2814 12.2814C14.1019 11.4609 15.2147 11 16.375 11C17.5353 11 18.6481 11.4609 19.4686 12.2814C20.2891 13.1019 20.75 14.2147 20.75 15.375Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0205 12.8926V15.7304H17.9124",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2106_304",
    x1: 10,
    y1: 20,
    x2: 10,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C40A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474DE6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/ZIP.cea1889c3eeab936e0371dd59659d92e.svg";
export { ForwardRef as ReactComponent };